import {
  GET_MANAGER_REVIEWS,
  GET_MANAGER_REVIEWS_FAILED,
  GET_MANAGER_REVIEWS_SUCCESS,
} from './actionTypes';

const initialState = {
  isLoadingGetManagerReviews: false,
  managerReviews: [],
  totalManagerReviews: 0,
};

export default function managerReview(state = initialState, action) {
  switch (action.type) {
    case GET_MANAGER_REVIEWS:
      return {
        ...state,
        isLoadingGetManagerReviews: true,
      };

    case GET_MANAGER_REVIEWS_SUCCESS:
      return {
        ...state,
        isLoadingGetManagerReviews: false,
        managerReviews: action.payload.data || [],
        totalManagerReviews: action.payload.total || 0,
      };

    case GET_MANAGER_REVIEWS_FAILED:
      return {
        ...state,
        isLoadingGetManagerReviews: false,
      };

    default:
      return state;
  }
}
